import { render } from "./UserTests.vue?vue&type=template&id=19e95202&scoped=true"
import script from "./UserTests.vue?vue&type=script&lang=js"
export * from "./UserTests.vue?vue&type=script&lang=js"

import "./UserTests.vue?vue&type=style&index=0&id=19e95202&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e95202"]])

export default __exports__